'use strict'
# TODO: Refactor filename/url assignment for live preview
define ['./passwordGuide.scss'], () ->
  (RentappService, $state, $filter, Upload, Landlord, RENTAPPLICATION_API_URL) ->
    restrict: "E"
    template: require("./passwordGuide.jade")
    link: (scope, element, attrs) ->
      scope.reset_pass = () ->
        scope.password_pass = false
        scope.length_pass = false
        scope.letter_pass = false
        scope.capital_pass = false
        scope.number_pass = false

      scope.check_pass = () ->
        if (typeof scope.match_pass != 'undefined')
          scope.password_pass = scope.match_pass && scope.length_pass && scope.letter_pass && scope.capital_pass && scope.number_pass
        else
          scope.password_pass = scope.length_pass && scope.letter_pass && scope.capital_pass && scope.number_pass

      scope.reset_pass()


      scope.$watch 'password', (new_password) ->
        if new_password
          # Validate min length
          scope.length_pass = !(new_password.length < 8)

          #Validate letter
          scope.letter_pass = (new_password.match(/[a-z]/) != null)

          # Validate uppercase letter
          scope.capital_pass = (new_password.match(/[A-Z]/) != null)

          #Validate number
          scope.number_pass = (new_password.match(/\d/) != null)

          scope.check_pass()
        else
          scope.reset_pass()





// WEBPACK FOOTER //
// ./directives/passwordGuide/passwordGuide.coffee